export function getColorFromStatusLabel(status) {
    if (status === "open")
        return "blue";
    else if (status === "pre-closed" || status === "close")
        return "green";
    else
        return "black";
}

export function getIconNameFromStatusLabel(status) {
    if (status === "open")
        return "play_arrow";
    else if (status === "close" || status === "pre-closed")
        return "check";
    else
        return "paused";
}

export function formatStatus(status) {
    if (status === "open")
        return "En cours";
    else if (status === "close" || status === "pre-closed")
        return "Terminé";

    return status;
}

export function getStateColor(status) {
    if (status === "close" || status === "pre-closed")
        return "ok-status-color";
    else if (status === "open")
        return "in-progress-status-color";

    return status;
}

export function formatInspectionState(inspectionState) {
    if (inspectionState === "new")
        return "Nouveau";
    else if (inspectionState === "planned")
        return "Planifié";
    else if (inspectionState === "finished")
        return "Terminé";
    else if (inspectionState === "cancelled")
        return "Annulé";

    return inspectionState;
}